module.exports = __webpack_public_path__ + "static/media/25ton-variant-5.6090c406.jpg";